import React, {useEffect, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import Api from "../../../Api/api";
import {toast} from "react-toastify";
import {formatDate} from "../../../helper/formatDate";
import {AiOutlineDelete, AiOutlineEdit} from "react-icons/ai";
import {SkewLoader} from "react-spinners";
import useModal from "../../../hooks/useModal";
import {useStateValue} from "../../../states/StateProvider";
import {AES, enc} from "crypto-js";
import Modal from "../../../hooks/modal";
import ModalWiedervorlage from "../../../hooks/modalWidervorlage";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";

const Reminders = ({id, userID, role, portal}) => {

    const [loading, setLoading] = useState(false)
    const [loadingData, setLoadingData] = useState(false)
    const [editing, setEditing] = useState(false)
    const [updated, setUpdated] = useState(0)
    const [options, setOptions] = useState([])
    const [author, setAuthor] = useState([])
    const [exists, setExists] = useState('0')
    const {toggleRemindersModal} = useModal();
    const [{remindersModal, remindersSaved, secretKey}, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const datePickerRef2 = useRef(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const {
        register,
        getValues,
        setValue,
        watch,
        handleSubmit,
        formState,
        reset,
        formState: {errors, touchedFields, isValid},
        control
    } = useForm({mode: "onChange"});

    function convertLocalToUTCDate(date) {
        if (!date) {
            return date
        }
        date = new Date(date)
        date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
        return date
    }

    useEffect(() => {
        setLoadingData(true)
        Api().get(`/reminderOptions/${portal}/${id}`).then(res => {
            setOptions(res.data.options)
            setAuthor(res.data.author)
            setExists(res.data.exists)
            setLoadingData(false)
        })
    }, [updated]);

    const onSubmit = (Data) => {
        setLoading(true)
        Data.portal = portal

        Api().post('/saveReminders', Data).then(res => {
            toast.success('Erinnerung erfolgreich gespeichert')
            setLoading(false)
            setUpdated(updated + 1)
            setEditing(false)
            dispatch({type: "SET_REMINDERS_MODAL", item: !remindersModal})
            dispatch({type: "SET_REMINDERS_SAVED", item: !remindersSaved})
        }).catch(e => {
            toast.error('irgendwas ist schief gelaufen!')
            setLoading(false)
        })
    };

    function deleteReminder() {
        setShowDeleteConfirm(true);
    }

    function confirmDeleteReminder() {
        setLoading(true)
        Api().get(`/deleteReminders/${portal}/${id}`)
            .then(res => {
                setUpdated(updated + 1);
                toast.success('Erfolgreich gelöscht');
                setValue('rmTitle', 'Wähle eine Option *');
                reset();
            })
            .catch(e => {
                toast.error('Etwas ist schief gelaufen!');
                setUpdated(updated + 1);
            })
            .finally(() => {
                setLoading(false)
                setShowDeleteConfirm(false);
            });
    }

    function setEditStates() {
        setEditing(true)
        setValue('rmTitle', author[0].rmTitle)
        setValue('rmText', author[0].rmText)
        setValue('uEmail', author[0].rmMail1)
        setValue('uEmail2', author[0].rmMail2)
        setValue('uEmail3', author[0].rmMail3)
        setValue('rmMailAMS', author[0].rmMailAMS === '1')
        setValue('rmMailKAM', author[0].rmMailKAM === '1')
        setValue('pauseICIM', author[0].pauseICIM === '1')
        setValue('date', convertLocalToUTCDate(author[0].rmDate))
        dispatch({type: "SET_REMINDERS_MODAL", item: !remindersModal})
    }

    function setInitialStates() {
        toggleRemindersModal()
        setValue('uEmail', user.email)
    }

    function cancelEditStates() {
        setEditing(false)
        dispatch({type: "SET_REMINDERS_MODAL", item: !remindersModal})
    }

    const style = {
        height: 'auto',
        width: '800px',
        'max-height': '100vh'
    };
    return (<div className='text-left px-2 pt-5 pb-2'>
        {loadingData ? <div style={{minHeight: '150px'}}>
            <SkewLoader size={10} color={'grey'}/>
        </div> : <div className='border border-b-1 border-b-offWhite border-x-0 border-t-0'>
            {exists === '0' ? <button
                className={`${role === 'Controller' && 'hidden'} px-3 py-2 my-4 hover:bg-lightBlue rounded-3xl bg-mainBlue text-white text-sm`}
                onClick={setInitialStates}
            >
                Neue Wiedervorlage
            </button> : <div>
                <div className="grid grid-cols-[auto_1fr] py-2 border-b border-silver gap-4 pl-2">
                    {/* Left column with label and action icons */}
                    <div className="flex flex-col">
                        <h2 className="text-base font-bold min-w-[120px] leading-5 mt-[1px]">Wiedervorlage</h2>
                        <div className="flex items-start space-x-2 mt-2">
                            <a title="bearbeiten" onClick={setEditStates} className="cursor-pointer">
                                <AiOutlineEdit size={20} className="text-blue-700" />
                            </a>
                            <a title="löschen" onClick={deleteReminder} className="cursor-pointer">
                                <AiOutlineDelete size={20} className="text-red-400" />
                            </a>
                        </div>
                    </div>

                    {/* Right column with data */}
                    <div className="flex flex-col justify-start">
                        <span className="text-sm font-semibold text-black"><label style={{color:"#a1a1a1"}}>am:</label> {formatDate(author[0].rmDate, false)}, {author[0].rmTitle}</span>
                        <div className="text-sm text-gray-600 mt-[1px]">
                            <span className="text-gray-400"><label style={{color:"#a1a1a1"}}>Erteller:</label> {author[0].rmUser}</span> / <span className="text-gray-400">{author[0].rmText}</span>
                        </div>
                        <div className="text-sm text-gray-600 mt-[1px]">
                            <span className="text-gray-400"><label style={{color:"#a1a1a1"}}>Erinnerungsemail für Projektforführung pausieren:</label> {author[0].pauseICIM === '1' ? 'Ja' : 'Nein'}</span>
                        </div>
                        <div className="text-sm text-gray-600 mt-[1px]">
                            <span className="text-gray-400">
                                <label style={{ color: "#a1a1a1" }}>Benachrichtigungen:</label>{" "}
                                {[author[0].rmMail1, author[0].rmMail2, author[0].rmMail3]
                                    .filter(Boolean)
                                    .join(", ")}
                                {(author[0].rmMailAMS === "1" || author[0].rmMailKAM === "1") && (
                                    <>
                                        {author[0].rmMailAMS === "1" && (
                                            <span className="text-xs text-gray-500">, DG KAM</span>
                                        )}
                                        {author[0].rmMailKAM === "1" && (
                                            <span className="text-xs text-gray-500">, DG AMS</span>
                                        )}
                                    </>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>}

        <Modal toggle={toggleRemindersModal}
               visible={remindersModal}
               styleDefined={style}
               component={<ModalWiedervorlage
                   toggleRemindersModal={toggleRemindersModal}
                   remindersModal={remindersModal}
                   options={options}
                   userID={userID}
                   id={id}
                   portal={portal}
                   role={role}
                   dispatch={dispatch}
                   onSubmit={handleSubmit(onSubmit)}
                   loading={loading}
                   watch={watch}
                   isValid={isValid}
                   errors={errors}
                   control={control}
                   register={register}
                   getValues={getValues}
                   datePickerRef2={datePickerRef2}
                   convertLocalToUTCDate={convertLocalToUTCDate}
                   cancelEditStates={cancelEditStates}
               />}
        />
        <ConfirmationModal
            visible={showDeleteConfirm}
            title="Wiedervorlage löschen"
            message="Möchten Sie diese Wiedervorlage wirklich löschen?"
            confirmText="Ja, löschen"
            cancelText="Abbrechen"
            onConfirm={confirmDeleteReminder}
            onCancel={() => setShowDeleteConfirm(false)}
            loading={loading}
        />
    </div>)
}

export default Reminders
